import { OnInit, Inject } from '@angular/core';

import { Modal, ModalAction, ModalResult } from './modal.component';
import { SystemPaths } from './system-paths';

declare var Pace, window;

export abstract class BaseComponent {

	protected pageEnabled: boolean;

	public modals:any;

	constructor(protected systemPaths: SystemPaths) {

		this.pageEnabled = true;

		this.modals = {};

		this.modals.overlay = {
			instance: null,

			loadedHandler: function(modal: Modal) {
				this.modals.overlay.instance = modal;

				if ( !this.pageEnabled ) {
					this.modals.overlay.instance.show();
				} else {
					this.modals.overlay.instance.hide();
				}
			}.bind(this),

			closedHandler: function(modalResult: ModalResult) {
			}.bind(this)
		};

		this.modals.genericOk = {
			instance: null,

			loadedHandler: function(modal: Modal) {
				this.modals.genericOk.instance = modal;
			}.bind(this),

			closedHandler: function(modalResult: ModalResult) {
			}.bind(this)
		};

		this.modals.unauthenticated = {
			instance: null,

			loadedHandler: function(modal: Modal) {
				this.modals.unauthenticated.instance = modal;
			}.bind(this),

			closedHandler: function(modalResult: ModalResult) {
				switch (modalResult.action) {
					case ModalAction.POSITIVE_EXTRA:
						this.gotoRegisterPage();
						break;

					case ModalAction.POSITIVE:
						this.gotoLoginPage();
						break;

					case ModalAction.CANCEL:
						break;

					default:
						break;
				}
			}.bind(this)
		};
	}

	public setPageEnabled(enabled:boolean) {
		if (this.modals.overlay.instance) {
			if (enabled) {
				this.modals.overlay.instance.hide();
				Pace.stop();
			} else {
				this.modals.overlay.instance.show();
				Pace.start();
			}
		}

		this.pageEnabled = enabled;

		// if ( this.cdRef ) {
		// 	this.cdRef.detectChanges();
		// }
	}

	public openUnauthenticatedModal() {
		this.modals.unauthenticated.instance.show();
	}

	private gotoRegisterPage() {
		window.location = this.systemPaths.register();
	}

	private gotoLoginPage() {
		window.location = this.systemPaths.login();
	}

	public removeTemporaryPropertiesFromObject(obj) {
		for ( const key of Object.keys(obj) ) {
			if ( key.startsWith("_") ) {
				delete obj[key];
			}
		}

		return obj;
	}

}
